.categories {
  grid-area: categories;
  display: grid;
  padding-inline: var(--cxy-spacing-4);
}
@media screen and (min-width: 801px) {
  .categories {
    padding-inline-start: 0;
  }
}

.sportFilter {
  padding-inline: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  gap: var(--cxy-spacing-2);
}
.sportFilter .pill.active {
  opacity: 1;
}
@media (min-width: 800px) {
  .sportFilter .pill:hover:not([disabled]) {
    background-color: var(--cxy-color-interactive-active);
    color: var(--cxy-color-content-dark);
    opacity: 1;
  }
}
@media (min-width: 1025px) {
  .sportFilter {
    overflow-x: scroll;
  }
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .categories {
    padding-inline: 0;
  }
  .sportFilter {
    padding-inline: var(--cxy-spacing-4);

    .pill {
      font-weight: var(--cxy-fontWeight-medium);
    }
  }

  @media screen and (min-width: 801px) {
    .categories {
      padding-inline-end: var(--cxy-spacing-4);
    }
    .sportFilter {
      padding-inline: 0;
    }
  }
}
